
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgot-password-confirmation',
  templateUrl: './forgot-password-confirmation.component.html',
  styles: [],
  styleUrls: ['./forgot-password-confirmation.component.css']
})
export class ForgotPasswordConfirmationComponent implements OnInit {
  isExpanded: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  toggle() {
    if (this.isExpanded) {
      this.isExpanded = false;
    }
    else {
      this.isExpanded = true;
    }

  }
  
}
